import { T, useI18n } from '@tribeplatform/react-components/i18n'

import { CustomHomepageSettingsFieldProps } from '../types.js'
import { CustomHomepageBaseFormField } from './CustomHomepageBaseFormField.js'

export const ReturningUsersHomepageFormField = ({
  formKey,
  defaultValue,
  isLoading,
  defaultHomepage,
}: CustomHomepageSettingsFieldProps) => {
  const { $t } = useI18n()

  return (
    <CustomHomepageBaseFormField
      formKey={formKey}
      defaultHomepage={defaultHomepage}
      defaultValue={defaultValue}
      isLoading={isLoading}
      label={$t({
        defaultMessage: 'Default homepage for returning {MEMBERS}',
        id: 'Admin.HomepageSettings.ReturningUsersHomepage',
      })}
      placeholder={$t({
        defaultMessage: 'Same as default homepage for logged-out visitors',
        id: 'Admin.HomepageSettings.SameAsDefaultForLoggedOut',
      })}
      helperText={<ReturningUsersHomepageHelperText />}
    />
  )
}

const ReturningUsersHomepageHelperText = () => {
  return (
    <p>
      <T
        defaultMessage="This is the landing page for existing {MEMBERS} returning to your site."
        id="Admin.HomepageSettings.ReturningUsersHomepageHelperText"
      />
    </p>
  )
}
